
// CUSTOMM

function openTab(evt, mainTab, subTab, nextTab) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }

  tabcontent2 = document.getElementsByClassName("tabcontent2");
  for (i = 0; i < tabcontent2.length; i++) {
    tabcontent2[i].classList.remove("active");
  }

  tabcontent3 = document.getElementsByClassName("tabcontent3");
  for (i = 0; i < tabcontent3.length; i++) {
    tabcontent3[i].classList.remove("active");
  }

  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  tablinks2 = document.getElementsByClassName("tablinks2");
  for (i = 0; i < tablinks2.length; i++) {
    tablinks2[i].className = tablinks2[i].className.replace(" active", "");
  }
  
  document.getElementById(mainTab).classList.add("active");
  evt.currentTarget.className += " active";

  document.getElementById(subTab).classList.add("active");
  evt.currentTarget.className += " active";

  document.getElementById(nextTab).classList.add("active");
  evt.currentTarget.className += " active";
}

function openTab2(evt, subTab, nextTab) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent2");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }

  tabcontent2 = document.getElementsByClassName("tabcontent3");
  for (i = 0; i < tabcontent2.length; i++) {
    tabcontent2[i].classList.remove("active");
  }
  
  tablinks = document.getElementsByClassName("tablinks2");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  
  document.getElementById(subTab).classList.add("active");
  evt.currentTarget.className += " active";

  document.getElementById(nextTab).classList.add("active");
  evt.currentTarget.className += " active";
}

function openTab3(evt, nextTab) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent3");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }
  tablinks = document.getElementsByClassName("tablinks3");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(nextTab).classList.add("active");
  evt.currentTarget.className += " active";
}
const customitem = document.querySelector(".Custom");
const customWrapper = document.querySelector(".custom-data");
customitem && customitem.addEventListener("click", function() {
    customWrapper.classList.toggle("active");
  if(customWrapper.classList.contains("active")){
      var scrollDiv = document.getElementById("custom2").offsetTop;
      window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
  }

  });

const customNav = document.querySelector(".site-nav__link--has-dropdown");
customNav && customNav.addEventListener("click", function(e) {
    e.preventDefault();
  });

const shareButton = document.querySelector(".share-icon");
const social_buttons = document.querySelector(".social_buttons");
shareButton && shareButton.addEventListener("click", function(e) {
    e.preventDefault();
    social_buttons.classList.toggle("active");
  });



// WishList Items Counter based on the localstorage

let wishlistItems = localStorage.getItem("wishlist-handles");
let countWishlistItems = wishlistItems.split(",").length;
// set wishlist count number
let wishlistIcons = document.querySelectorAll("[data-js-wishlist-item-count]");
wishlistIcons.forEach(wishlistIcon => {
  console.log("countWishlistItems",countWishlistItems)
  wishlistIcon.innerText = countWishlistItems;
  wishlistIcon.classList.add('is-active');
});

var originalSetItem = localStorage.setItem;
localStorage.setItem = function(){
  document.createEvent('Event').initEvent('itemInserted', true, true);
  originalSetItem.apply(this, arguments);
  let data = localStorage.getItem("wishlist-handles");
  let count = data.split(",").length;
  wishlistIcons.forEach(wishlistIcon => {
    if(count == 0){
      wishlistIcon.classList.remove('is-active');
    }
    else{
      wishlistIcon.classList.add('is-active');
    }
    wishlistIcon.innerText = count;
  });
}




